import { render, staticRenderFns } from "./TheContactsPage.vue?vue&type=template&id=be5f6f06&scoped=true"
import script from "./TheContactsPage.vue?vue&type=script&lang=js"
export * from "./TheContactsPage.vue?vue&type=script&lang=js"
import style0 from "./TheContactsPage.vue?vue&type=style&index=0&id=be5f6f06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5f6f06",
  null
  
)

export default component.exports